module.exports = __webpack_public_path__ + "event-white.svg?b91f2d766d2c0d00bfb155b7b6d93563";